import { Command, HttpMethod } from "~/extensions/api";
import { sha256 } from "~/extensions/utils";
export class MTLoginCommand extends Command {
    constructor(model) {
        super(HttpMethod.Post, "auth/Mt/login");
        this.loginId = model.loginId;
        this.password = sha256(model.password);
        this.appJsHash = model.appJsHash;
        this.vendorJsHash = model.vendorJsHash;
    }
    loginId = "";
    password = "";
    appJsHash = "";
    vendorJsHash = "";
}
